import { addGhostIds } from "@/utils";
import AccountsMixin from "@/mixins/AccountsMixin.vue";
import FetchFiltersMixin from "@/mixins/FetchFiltersMixin.vue";
import { isObjectEmpty, tryParse } from "@/utils";
import Filter from "@/store/filter";
import { Currencies } from "../utils/currencies";
export default {
  name: "InitializeFiltersMixin",
  mixins: [AccountsMixin, FetchFiltersMixin],
  methods: {
    async initializeSellersFilters({
      sellers
    }, sellersFilter) {
      sellersFilter.initialize({
        list: addGhostIds(sellers),
        selected: [],
        name: "sellers_filter",
        key: "id",
        autoSelect: true
      });
      // Return `id`s array
      return sellers.map(seller => seller.id);
    },
    // async initializeFilters(
    //   { sellers },
    //   // Location object
    //   parent,
    //   { seller, marketplace },
    //   rootPath
    // ) {
    //   const initializeStart = performance.now();
    //   if (!seller) return;
    //   const seller_ids = await this.initializeSellersFilters(
    //     { sellers },
    //     parent,
    //     seller,
    //     rootPath
    //   );
    //   if (!marketplace) return;
    //   const sales_channel = await this.initializeMarketplacesFilters(
    //     {
    //       sellers: seller_ids,
    //     },
    //     parent,
    //     marketplace,
    //     rootPath
    //   );

    //   // This task can be done in parallel since the only important filters are the first two
    //   // Sellers and Marketplaces

    //   const initializeEnd = performance.now();

    // //  console.log(
    // //     `[Perf][InitializeFilter.initializeFilters]: ${(initializeEnd - initializeStart) / 1000
    // //     } s`
    // //   );
    //   return { sales_channel, seller_ids };
    // },

    async initializeMarketplacesFilters({
      sellers
    }, marketplacesFilter, rootPath) {
      //console.log("initializeMarketplaces", new Date().toISOString());
      const path = `/${rootPath}/filters/countries`;
      const marketplaces = await this.getCountriesBasedOnSellers({
        sellers
      }, path);
      marketplacesFilter.initialize({
        list: marketplaces,
        selected: [],
        name: "marketplaces_filter",
        key: "sales_channel",
        autoSelect: true
      });
      return marketplaces.filter(({
        sales_channel
      }) => sales_channel !== "-").map(marketplace => marketplace.sales_channel);
    },
    async initializeProductsFilters({
      sellers,
      sales_channel,
      segment_list = []
    }, productsFilter, rootPath) {
      // Get the sales channel from the store
      const path = `/${rootPath}/filters/products`;
      const products = await this.getProductsSuggestionsBasedOnSellers({
        sellers,
        sales_channel,
        segment_list
      }, path);
      productsFilter.initialize({
        list: products,
        selected: [],
        key: "id",
        name: "products_filter",
        asyncSearcher: params => this.getProductsSuggestionsBasedOnSellers({
          ...params,
          segment_list
        }, path),
        autoSelect: true
      });
    },
    async initializeCampaignsFilters({
      sellers,
      sales_channel,
      portfolio_id_list,
      ad_format_list,
      campaign_group_list
    }, campaignsFilter, rootPath) {
      const path = `/${rootPath}/filters/campaigns`;
      // Kept in the asyncSearcher closure so searching stays scoped to the parent filters.
      const relations = {
        portfolio_id_list,
        ad_format_list,
        campaign_group_list
      };
      const campaigns = await this.getCampaignsBasedOnSellers({
        sellers,
        sales_channel,
        ...relations
      }, path);
      campaignsFilter.initialize({
        list: campaigns?.slice(0, 100),
        selected: [],
        key: "id",
        name: "campaigns_filter",
        asyncSearcher: params => this.getCampaignsBasedOnSellers({
          ...relations,
          ...params
        }, path)
      });
    },
    async initializeCampaignGroupsFilters({
      sellers,
      sales_channel,
      portfolio_id_list,
      ad_format_list
    }, campaignGroupsFilter, rootPath) {
      const path = `/${rootPath}/filters/campaign_groups`;
      // Kept in the asyncSearcher closure so searching stays scoped to the parent filters.
      const relations = {
        portfolio_id_list,
        ad_format_list
      };
      const campaignGroups = await this.getCampaignGroupsBasedOnSellers({
        sellers,
        sales_channel,
        ...relations
      }, path);

      //console.log("campaign Groups", campaignGroups)
      campaignGroupsFilter.initialize({
        list: campaignGroups?.slice(0, 100),
        selected: [],
        key: "id",
        name: "campaign_groups_filter",
        asyncSearcher: params => this.getCampaignGroupsBasedOnSellers({
          ...relations,
          ...params
        }, path)
      });
    },
    async initializePortfoliosFilters({
      sellers,
      sales_channel
    }, portfoliosFilter, rootPath) {
      const path = `/${rootPath}/filters/portfolios`;
      const portfolios = await this.getPortfoliosBasedOnSellers({
        sellers,
        sales_channel
      }, path);
      portfoliosFilter.initialize({
        list: portfolios?.slice(0, 100),
        selected: [],
        key: "portfolio_id",
        name: "portfolios_filter",
        asyncSearcher: params => this.getPortfoliosBasedOnSellers({
          ...params
        }, path)
      });
    },
    async initializeAdFormatsFilters({
      sellers
    }, adFormatsFilter, rootPath) {
      const path = `/${rootPath}/filters/ad_formats`;
      const ad_formats = await this.getAdFormatsBasedOnSellers({
        sellers
      }, path);
      adFormatsFilter.initialize({
        list: ad_formats,
        selected: [],
        name: "ad_formats_filter"
      });
    },
    async initializeMatchTypesFilters({
      sellers
    }, matchTypesFilter, rootPath) {
      const path = `/${rootPath}/filters/match_types`;
      const match_types = await this.getMatchTypesBasedOnSellers({
        sellers
      }, path);
      matchTypesFilter.initialize({
        list: match_types,
        selected: [],
        key: "id",
        name: "match_types_filter"
      });
    },
    async initializeTargetingsFilters({
      sellers,
      sales_channel
    }, targetingsFilter, rootPath) {
      const path = `/${rootPath}/filters/targetings`;
      const targetings = await this.getTargetingsBasedOnSellers({
        sellers,
        sales_channel
      }, path);
      targetingsFilter.initialize({
        list: targetings?.slice(0, 100),
        selected: [],
        key: "keyword_id_list",
        name: "tagetings_filter",
        asyncSearcher: params => this.getTargetingsBasedOnSellers({
          ...params
        }, path)
      });
    },
    initializeCurrenciesFilters({
      sellers
    }, parent, currency) {
      const currencies = this.getCurrencies(sellers);
      this.$store.state[parent][currency].initialize({
        list: currencies,
        selected: [],
        key: "currency",
        name: "currency_filter"
      });
    },
    fetchSubFilters({
      sellers,
      sales_channel
    }, parent, {
      product,
      targeting,
      match_type,
      campaign,
      portfolio,
      ad_format
    }, rootPath) {
      const promises = [];
      if (product) {
        promises.push(this.initializeProductsFilters({
          sellers,
          sales_channel
        }, parent, product, rootPath));
      }
      if (targeting) {
        promises.push(this.initializeTargetingsFilters({
          sellers,
          sales_channel
        }, parent, targeting, rootPath));
      }
      if (match_type) {
        promises.push(this.initializeMatchTypesFilters({
          sellers
        }, parent, match_type, rootPath));
      }
      if (campaign) {
        promises.push(this.initializeCampaignsFilters({
          sellers,
          sales_channel
        }, parent, campaign, rootPath));
      }
      if (portfolio) {
        promises.push(this.initializePortfoliosFilters({
          sellers,
          sales_channel
        }, parent, portfolio, rootPath));
      }
      if (ad_format) {
        promises.push(this.initializeAdFormatsFilters({
          sellers,
          sales_channel
        }, parent, ad_format, rootPath));
      }
      Promise.all(promises);
    },
    async initializeSellersFilter(commitFilterFunction) {
      let current_workspace = tryParse(localStorage.getItem("current_workspace"));
      if (!current_workspace) {
        await this.refreshSellersFilter();
        return;
      }
      let any_saved_seller_filter = localStorage.getItem(current_workspace.workspace_id + "sellers_filter");
      if (!!any_saved_seller_filter && !isObjectEmpty(any_saved_seller_filter) && Filter.deserialize(any_saved_seller_filter)?.selected.length) {
        //console.log("any_saved_seller_filter", any_saved_seller_filter);
        commitFilterFunction(Filter.deserialize(any_saved_seller_filter));
      } else {
        await this.refreshSellersFilter();
      }
    },
    async refreshSellersFilter() {
      // Setup Filters
      let sellers = await this.getFilterValuesForSellersFilter();
      if (sellers?.length > 0) {
        await this.getOmnyAccountProfileIds(sellers);
        this.sellers_filter.initialize({
          list: sellers,
          selected: [],
          name: "sellers_filter",
          key: "id",
          autoSelect: true
        });
      } else {
        this.handleErrorOccured();
      }
    },
    async initializeMarketplacesFilter(commitFilterFunction, check_local_storage) {
      let current_workspace = tryParse(localStorage.getItem("current_workspace"));
      let any_saved_marketplace_filter = localStorage.getItem(current_workspace?.workspace_id + "marketplaces_filter");
      if (any_saved_marketplace_filter && !isObjectEmpty(any_saved_marketplace_filter) && Filter.deserialize(any_saved_marketplace_filter)?.selected.length && check_local_storage) {
        commitFilterFunction(Filter.deserialize(any_saved_marketplace_filter));
      } else {
        await this.refreshMarketPlacesFilter();
      }
    },
    async refreshMarketPlacesFilter() {
      // Setup Filters
      let marketplaces = await this.getFilterValuesForMarketPlacesFilter();
      if (marketplaces?.length > 0) {
        this.marketplaces_filter.initialize({
          list: marketplaces,
          selected: [],
          name: "marketplaces_filter",
          key: "sales_channel",
          autoSelect: true
        });
      } else {
        this.handleErrorOccured();
      }
    },
    async initializeKeywordsListFilter(commitFilterFunction, module_name) {
      let keyword_list = [];
      let current_workspace = tryParse(localStorage.getItem("current_workspace"));
      let any_saved_keywords_list_filter = tryParse(localStorage.getItem(current_workspace.workspace_id + module_name + "keywords_list_filter"));
      if (!!any_saved_keywords_list_filter && !isObjectEmpty(any_saved_keywords_list_filter)) {
        commitFilterFunction(any_saved_keywords_list_filter);
      } else {
        commitFilterFunction(keyword_list);
      }
    },
    getAnySavedDatePickerDate() {
      let current_workspace = tryParse(localStorage.getItem("current_workspace"));
      let any_saved_date_picker_date = tryParse(localStorage.getItem(current_workspace?.workspace_id + "date_picker"));
      return any_saved_date_picker_date;
    },
    async initializeSegmentsFilter({
      sellers
    }, segments, rootPath) {
      // Get the sales channel from the store
      const path = `/${rootPath}/filters/segments`;
      const results = await this.getSegmentsBasedOnSellers({
        sellers
      }, path);
      segments.initialize({
        list: results,
        selected: [],
        key: "id",
        name: "segments_filter",
        asyncSearcher: ({
          keyword,
          seller_id
        }) => this.getSegmentsBasedOnSellers({
          sellers: seller_id,
          keyword
        }, path)
      });
    },
    async initializeBrandsFilter({
      sellers
    }, brands, rootPath) {
      // Get the sales channel from the store
      const path = `/${rootPath}/filters/brands`;
      const results = await this.getBrandsBasedOnSellers({
        sellers
      }, path);
      brands.initialize({
        list: results,
        selected: [],
        key: "brand",
        name: "brand_filter"
      });
    }
  }
};